export default function BackgroundIcon() {
  return (
    <div className="background-icon">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 42 35">
        <defs>
          <linearGradient>
            <stop offset="0" stopColor="#a8a8a8" stopOpacity="1" />
          </linearGradient>
          <marker orient="auto" overflow="visible" refX="0" refY="0">
            <path
              fill="#000"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="#000"
              strokeOpacity="1"
              strokeWidth=".8pt"
              d="M4.616 0l-6.92 4v-8z"
            />
          </marker>
          <marker orient="auto" overflow="visible" refX="0" refY="0">
            <path
              fill="#a1a1a1"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="#a1a1a1"
              strokeOpacity="1"
              strokeWidth=".8pt"
              d="M-4.616 0l6.92-4v8z"
            />
          </marker>
          <marker orient="auto" overflow="visible" refX="0" refY="0">
            <path
              fill="#000"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="#000"
              strokeOpacity="1"
              strokeWidth=".8pt"
              d="M10 0l4-4L0 0l14 4z"
            />
          </marker>
          <path d="M198.047 -13.096H237.87V67.085H198.047z" />
          <path d="M-14.363 48.381H57.83V80.887H-14.363z" />
          <path d="M94.346 72.965H182.01V84.19H94.346z" />
          <path d="M-21.382 74.034H180.13899999999998V168.647H-21.382z" />
          <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
          <path d="M16.631 99.786H281.006V158.796H16.631z" />
          <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
          <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
          <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
          <path d="M87.664 107.977H225.84199999999998V173.993H87.664z" />
          <marker orient="auto" overflow="visible" refX="0" refY="0">
            <path
              fill="#a1a1a1"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="#a1a1a1"
              strokeOpacity="1"
              strokeWidth=".8pt"
              d="M-4.616 0l6.92-4v8z"
            />
          </marker>
          <path d="M16.631 99.786H281.006V158.796H16.631z" />
          <path d="M16.631 99.786H281.006V158.796H16.631z" />
          <path d="M16.631 99.786H281.006V158.796H16.631z" />
          <path d="M16.631 99.786H281.006V158.796H16.631z" />
          <marker id="marker1763-25" orient="auto" overflow="visible" refX="0" refY="0">
            <path
              fill="#a8a8a8"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="#a8a8a8"
              strokeOpacity="1"
              strokeWidth=".8pt"
              d="M-4.616 0l6.92-4v8z"
            />
          </marker>
          <marker id="marker1763-25-4" orient="auto" overflow="visible" refX="0" refY="0">
            <path
              fill="#a8a8a8"
              fillOpacity="1"
              fillRule="evenodd"
              stroke="#a8a8a8"
              strokeOpacity="1"
              strokeWidth=".8pt"
              d="M-4.616 0l6.92-4v8z"
            />
          </marker>
        </defs>
        <g strokeDasharray="none" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="4" strokeOpacity="1">
          <path fill="none" stroke="#a7bbdc" strokeWidth="4.265" d="M30.479 17.338H11.695" />
          <path fill="#ef0e0e" fillOpacity="1" stroke="#a8a8a8" strokeWidth="4.087" d="M32.667 13.776H15.099" />
          <path
            fill="none"
            stroke="#a8a8a8"
            strokeWidth="1.06"
            markerStart="url(#marker1763-25)"
            d="M35.628 13.785h-1.47l3.105-.072"
          />
          <path
            fill="none"
            stroke="#a8a8a8"
            strokeWidth="1.06"
            markerStart="url(#marker1763-25-4)"
            d="M6.575 20.88l1.552-.006v0"
          />
          <path fill="#000" fillOpacity="1" stroke="#a8a8a8" strokeWidth="4.382" d="M26.883 20.808H8.21" />
        </g>
      </svg>
    </div>
  );
}
